














import {
  Component,
  Prop,
  Vue,
  Watch,
  Provide,
  Inject,
  PropSync,
} from "vue-property-decorator";
import Spinner from "@/components/Spinner.vue";
import TOMFragebogen from "../TOMFragebogen";

@Component({
  components: {
    Spinner,
  },
})
export default class TOMFragebogenBausteinGruppe extends Vue {
  public isLoading: boolean = true;
  @Prop({ default: undefined }) className?: string;
  @Prop({ default: false }) amSuchen!: boolean;
  @Prop({ default: true }) buttonsSichtbar!: boolean;
  @PropSync("hauptBaustein", { required: true })
  internalBaustein!: TOMFragebogen.Baustein;

  // public onAdd(art: TOMFragebogen.Baustein.Art) {
  //   const neuerBaustein = TOMFragebogen.Logic.createBaustein(
  //     TOMFragebogen.Baustein.Art[
  //       art
  //     ] as keyof typeof TOMFragebogen.Baustein.Art,
  //     ["", ""],
  //     ["", ""]
  //   );

  //   this.$emit("add", neuerBaustein, this.internalBaustein);
  // }
}
